import React from "react";
import Icon, { IconType } from "../../../atoms/icon/Icon";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import VerticalGroup from "../../../atoms/verticalgroup/VerticalGroup";
import RoundResultsContainer from "../components/RoundsResultsContainer";
import ResultsText from "../results-text/ResultsText";
import { ResponsiveSize } from "../../../atoms/image/Image";
import EditableReportingHeading from "../components/EditableReportingHeading";

interface Props {}

interface TextAndIconBlockProps {
  heading: string;
  points: string[];
  iconType: IconType;
  dynamicSize: ResponsiveSize;
}

const TextAndIconBlock: React.FC<TextAndIconBlockProps> = ({
  heading,
  points,
  iconType,
  dynamicSize,
}) => {
  return (
    <VerticalGroup wide>
      <InlineGroup verticalCenter block spaceBetweenElements={8}>
        <Icon type={iconType} dynamicSize={dynamicSize} noMargin></Icon>
        <ResultsText bold size="xl">
          {heading}
        </ResultsText>
      </InlineGroup>

      <VerticalGroup style={{ marginLeft: "9%" }} wide className=" pl-1">
        <ul>
          <VerticalGroup spaceBetweenElements={4}>
            {points.map((p) => (
              <li key={p}>
                <ResultsText size="md">{p}</ResultsText>
              </li>
            ))}
          </VerticalGroup>
        </ul>
      </VerticalGroup>
    </VerticalGroup>
  );
};

const RoundResultsReversion: React.FC<Props> = () => (
  <RoundResultsContainer>
    <VerticalGroup full center wide spread style={{ height: "90%" }}>
      <VerticalGroup spaceBetweenElements={2} center wide>
        <EditableReportingHeading defaultHeading="Simulation Final Round" />
        <ResultsText size="xl" bold center colour="blue">
          What happens to our banks after this round?
        </ResultsText>
      </VerticalGroup>
      <VerticalGroup center wide style={{ width: "80%" }}>
        <TextAndIconBlock
          dynamicSize={{ min: "70px", preferred: "5.2vw", max: "800px" }}
          iconType="clock"
          heading='Banks continue to operate for 5 more years (to prevent "gaming" and capture long-term impacts):'
          points={[
            "All pricing decisions revert to the mean",
            "Treasury managed optimally (A credit rating maintained)",
            "Secondary levers reset to beginning settings (excl branch networks)",
          ]}
        />
      </VerticalGroup>
      <VerticalGroup center wide style={{ width: "80%" }}>
        <TextAndIconBlock
          dynamicSize={{ min: "50px", preferred: "5vw", max: "800px" }}
          iconType="diamond"
          heading="How do I differentiate my bank?"
          points={[
            "Points of presence (branch networks)",
            "Change initiatives selected",
            "Non-financial transformation progress",
            "Deals done",
          ]}
        />
      </VerticalGroup>
    </VerticalGroup>
  </RoundResultsContainer>
);

export default RoundResultsReversion;
